import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing';
import { MUTATION_KEYS, QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';
import { CreateUserMappingProps } from 'shared/service';

export function useCreateUserMapping() {
  const { userMappingService } = useService();
  const history = useHistory();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutation = useMutation<void, Error, CreateUserMappingProps>(
    request => userMappingService.createUserMapping(request),
    {
      mutationKey: MUTATION_KEYS.createUserMapping,
      onSuccess: () => {
        enqueueSnackbar('mapping created successfully', { variant: 'success' });
        history.push(ROUTES.userMapping);
      },
      onError: () => {
        enqueueSnackbar('there was a problem creating mapping', { variant: 'error' });
      },
      onSettled: () => {
        queryClient.invalidateQueries(QUERY_KEYS.userMappings);
      },
    }
  );

  return mutation;
}
